/**
 * Mira-Ausnahmen as the IRES Admin Client shows them (Hans, Track #2610040 R8): a Mandant recorded an
 * event late between two days, so Mira leaves the durations built on it out. Mirrors the IRES Cloud
 * callables in `MiraExceptionsForAdministration.ts`; the rules live in Cloud `lateRecordings.ts`.
 */

/** The events an entry can name: the project's end, or the insurer's answer (Freigabe). */
export const MIRA_LATE_EVENTS = ["PROJECT_END", "OFFER_ANSWER"] as const;
export type MiraLateEvent = typeof MIRA_LATE_EVENTS[number];

/** One entry. */
export interface MiraException {
  id: string;
  clientId: string;
  event: MiraLateEvent;
  /** `YYYY-MM-DD`, inclusive. */
  from: string;
  /** `YYYY-MM-DD`, inclusive. */
  to: string;
  reason: string;
  retired: boolean;
  /** Epoch ms of the last save, the token of the changed-meanwhile check. */
  updatedAt: number | null;
  updatedBy: string | null;
}

/** What a save sends. */
export interface MiraExceptionSave {
  id: string | null;
  clientId: string;
  event: MiraLateEvent;
  from: string;
  to: string;
  reason: string;
  retired: boolean;
  expectedUpdatedAt: number | null;
}

/**
 * P1: the figure a suggestion's event distorts, for its Mandant over one calendar year: Projektdauer
 * (`MIRA-PRJ-002`) or Freigabedauer (`MIRA-INS-004`), the mean and median in days with and without the late
 * projects.
 */
export interface MiraExceptionSuggestionFigure {
  metricId: string;
  year: number;
  /** The tile leads with the mean, so it is shown beside the median. */
  meanWith: number | null;
  meanWithout: number | null;
  medianWith: number | null;
  medianWithout: number | null;
  basisWith: number;
  basisWithout: number;
}

/**
 * A day range on which a Mandant recorded many closings or answers late, found by Mira overnight (R8
 * Phase 3, IRES Cloud `exceptionSuggestions.ts`). Only open suggestions reach the IRES Admin Client.
 */
export interface MiraExceptionSuggestion {
  id: string;
  clientId: string;
  event: MiraLateEvent;
  /** `YYYY-MM-DD`, inclusive. */
  from: string;
  /** `YYYY-MM-DD`, inclusive. */
  to: string;
  /** Projects closed (or answered) in the days. */
  projects: number;
  /** Of them, recorded late. */
  late: number;
  figure: MiraExceptionSuggestionFigure | null;
  /** Epoch ms, the token of the changed-meanwhile check. */
  updatedAt: number | null;
}

/** What a dismissal sends. */
export interface MiraExceptionSuggestionDismissal {
  id: string;
  reason: string;
  expectedUpdatedAt: number | null;
}
